<a [routerLink]="canBeOpened ? ['/annual-statement', documentId] : null">
  <app-entity-name-number-record
    class="company-name-acn"
    [name]="name"
    [numberFormatted]="acn | acn"
  />
</a>
